import React from 'react';
import {
  Folder,
  Users,
  ExternalLink,
  MousePointerClick,
  UserMinus,
  Send,
  CircleCheck,
  CircleX,
  Globe,
  UserPlus,
  CreditCard,
  Banknote,
  Star,
  MessageSquare,
  AlertTriangle,
  CheckCircle2,
  PlusCircle,
  Hourglass,
  MessageCircle,
  RefreshCw,
} from 'lucide-react';
import { acmeIconTones } from '../../theme/acmeTheme';

const ICON_COMPONENTS = {
  campaigns: Folder,
  recipients: Users,
  opens: ExternalLink,
  clicks: MousePointerClick,
  unsubscribed: UserMinus,
  sent: Send,
  delivered: CircleCheck,
  failed: CircleX,
  viewPage: Globe,
  registerUsers: UserPlus,
  buyPlan: CreditCard,
  projects: Folder,
  allMoney: Banknote,
  plan: Star,
  sms: MessageSquare,
  warning: AlertTriangle,
  check: CheckCircle2,
  projectNew: PlusCircle,
  projectPending: Hourglass,
  projectCommunication: MessageCircle,
  projectPendingPayment: Banknote,
  projectProcessing: RefreshCw,
  projectClosed: CheckCircle2,
};

/** Lucide props — soft stroke icons like Tanplates / shadcn */
export function getMetricIconProps({ size = 32, tone = 'default' } = {}) {
  return {
    size,
    strokeWidth: 1.5,
    color: acmeIconTones[tone] || acmeIconTones.default,
  };
}

/** Render a dashboard metric icon with consistent soft styling */
export function DashboardMetricIcon({ name, size = 32, tone = 'default', ...rest }) {
  const Icon = ICON_COMPONENTS[name];
  if (!Icon) return null;
  return <Icon {...getMetricIconProps({ size, tone })} {...rest} />;
}

/** Pre-built icons for stat cards (email tab) */
export const emailMetricIcons = {
  campaigns: <DashboardMetricIcon name="campaigns" />,
  recipients: <DashboardMetricIcon name="recipients" />,
  opens: <DashboardMetricIcon name="opens" />,
  clicks: <DashboardMetricIcon name="clicks" />,
  unsubscribed: <DashboardMetricIcon name="unsubscribed" tone="destructive" />,
};

/** SMS tab stat icons */
export const smsMetricIcons = {
  campaigns: <DashboardMetricIcon name="campaigns" />,
  recipients: <DashboardMetricIcon name="recipients" />,
  sent: <DashboardMetricIcon name="sent" />,
  delivered: <DashboardMetricIcon name="delivered" tone="success" />,
  failed: <DashboardMetricIcon name="failed" tone="destructive" />,
};

/** Project status stat icons */
export const projectStatusIcons = {
  NEW: <DashboardMetricIcon name="projectNew" />,
  PENDING: <DashboardMetricIcon name="projectPending" />,
  COMMUNICATION: <DashboardMetricIcon name="projectCommunication" />,
  'PENDING PAYMENT': <DashboardMetricIcon name="projectPendingPayment" />,
  'IN PROCESSING': <DashboardMetricIcon name="projectProcessing" />,
  CLOSED: <DashboardMetricIcon name="projectClosed" tone="success" />,
};

/** Traffics tab stat icons */
export const trafficMetricIcons = {
  viewPage: <DashboardMetricIcon name="viewPage" />,
  registerUsers: <DashboardMetricIcon name="registerUsers" />,
  buyPlan: <DashboardMetricIcon name="buyPlan" />,
  projects: <DashboardMetricIcon name="projects" />,
  allMoney: <DashboardMetricIcon name="allMoney" tone="foreground" />,
};
